import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import classNames from "classnames";

import { logout } from "../../store/actions/user";

import Player from "../Player";
import { ReactComponent as Logo } from "../../assets/shuffle.svg";
import { Loading } from "../Icons";
import LogoutButton from "../Logout";
import Avatar from "../Avatar";
import styles from "./Header.module.scss";

const Header = props => {
  const { user, showPlayer } = props;
  return (
    <nav className="bg-dark navbar navbar-dark text-light sticky-top" id="header">
      <span className="navbar-brand"><Logo fill="#fff" className={styles.logo} /></span>
      {Object.keys(props.loading).filter(key => props.loading[key]).length > 0 && <Loading colors="#fff" width="40" height="40" />}
      {user &&
        <div className="d-flex align-items-center">
          {showPlayer && <Player btnClassName="text-white"/>}
          <div className="d-flex flex-column">
            <small className={styles.email}>{user.email}</small>
            <LogoutButton
              size="sm"
              onLogout={props.logout}
              className='p-0'
            />
          </div>
          <Avatar
            user={user}
            height="40"
            className={classNames("mr-2 rounded-circle", styles.avatar)}
          />
        </div>
      }
    </nav>
  )
}

export default connect(
  state => (
    {
      user: state.user,
      loading: state.loading,
      showPlayer: state.audio.src
    }
  ),
  dispatch => bindActionCreators({
    logout
  }, dispatch)
)(Header)